import React, { useRef, useState } from 'react'

import { LinkHelp, ButtonHelp } from './ButtonHelpToAccess.styles'
import { HELP_TO_ACCESS_PATH } from './ButtonHelpToAcess.constants'
import { useTranslation } from 'i18n'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'

const ButtonHelpToAccess = () => {
  const [openHelp, setOpenHelp] = useState(false)
  const timeoutId = useRef<number>()
  const { t } = useTranslation()

  const clearLastTimeout = () => {
    if (timeoutId.current) window.clearTimeout(timeoutId.current)
  }
  const handleMouseEnter = () => {
    clearLastTimeout()
    setOpenHelp(true)
  }
  const handleMouseLeave = () => {
    clearLastTimeout()
    timeoutId.current = window.setTimeout(() => {
      setOpenHelp(false)
    }, 2000)
  }

  return (
    <LinkHelp
      style={{ position: 'absolute', right: '57px', bottom: '57px' }}
      href={HELP_TO_ACCESS_PATH}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ButtonHelp data-testid="help-to-access" openHelp={openHelp}>
        <FontIcon
          iconName="information"
          color={tokens.colors.dark5}
          size={24}
        />
        <strong>{t('Precisa de ajuda para acessar?')}</strong>
      </ButtonHelp>
    </LinkHelp>
  )
}

export default ButtonHelpToAccess
